import React from 'react';
import styled, {css} from "styled-components";

const StyledButton = styled.button`
  font-size: 16px;
  padding: 12px 24px;
  background-color: #13D6D1;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: unset;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  min-width: 175px;
  font-family: 'Gilroy-Medium', sans-serif;
  ${({lg}) => lg && css`
    padding: 16px 32px;
  `}
  ${({danger}) => danger && css`
    background-color: #ef466f;
  `}
  ${({green}) => green && css`
    background-color: #36BA6B;
  `}
  ${({yellow}) => yellow && css`
    background-color: #FFE5A2;
    color: #000;
  `}
  ${({transparent}) => transparent && css`
    background-color: transparent;
    color: #000;
  `}
  ${({dark}) => dark && css`
    background-color: #1D283A;
  `}
  ${({gray}) => gray && css`
    background-color: #DFDFDF;
    color: #000;
  `}

  &:disabled {
    cursor: not-allowed;
    opacity: 1;
  }

  ${({inline}) => inline && css`
    min-width: unset;
  `}
  ${({sm}) => sm && css`
    padding: 9px 12px;
  `}
  ${({xs}) => xs && css`
    padding: 6px 8px;
    min-width: unset;
    font-size: 14px;
    width: 100%;

    span {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  `}
  ${({block}) => block && css`
    display: block;
    text-align: center;
    width: 100%;
  `}

  > div {
    width: 100%;
    min-width: 0;
  }

  svg {
    flex: 0 0 auto;
  }

  span {
    min-width: 0;
    font-size: inherit;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: break-word;
  }
`;

const Button = ({...rest}) => {
  return (
      <StyledButton  {...rest} />
  );
};

export default Button;
